import { render } from "./ClientInvoices.vue?vue&type=template&id=10741c33&scoped=true"
import script from "./ClientInvoices.vue?vue&type=script&lang=js"
export * from "./ClientInvoices.vue?vue&type=script&lang=js"

import "./ClientInvoices.vue?vue&type=style&index=0&id=10741c33&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10741c33"]])

export default __exports__